import React from 'react';
import { EyeOff, X } from 'react-feather';

import { blockMessageFor } from './commentBlockReasons';

export default function CommentBlockedNotice({ reason, onDismiss }) {

    const { title, action } = blockMessageFor(reason);

    return (
        <div
            role="status"
            className="mt-2 flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2"
        >
            <EyeOff className="mt-[2px] h-4 w-4 shrink-0 text-amber-600" />

            <div className="min-w-0 flex-1">
                <p className="text-[13px] font-medium leading-snug text-amber-900">
                    Não enviada ao cliente. {title}.
                </p>
                <p className="mt-0.5 text-[13px] leading-snug text-amber-800">
                    {action}
                </p>
            </div>

            <button
                type="button"
                aria-label="Fechar aviso"
                onClick={onDismiss}
                className="shrink-0 rounded p-0.5 text-amber-600 hover:bg-amber-100"
            >
                <X className="h-4 w-4" />
            </button>
        </div>
    );
}
